import { Error } from '@clearkit/icons';
import { CKBannerNext } from 'clearkit';
import { CSSTransition } from 'react-transition-group';

import { AuthBannerProps } from './bannerTypes';

export const BannerError = ({ children, isVisible }: AuthBannerProps) => {
  return (
    <CSSTransition
      classNames="ck-fade"
      in={isVisible}
      mountOnEnter
      timeout={300}
      unmountOnExit
    >
      <CKBannerNext className="w-full" variant="error">
        <CKBannerNext.IconStatus>
          <Error />
        </CKBannerNext.IconStatus>
        <CKBannerNext.Header>Something went wrong</CKBannerNext.Header>
        <CKBannerNext.Body>{children}</CKBannerNext.Body>
      </CKBannerNext>
      );
    </CSSTransition>
  );
};
